import { ACTION_HOTKEYS, HELP_KEY, TAB_HOTKEYS, keyLabel } from "../../lib/hotkeys";
import { Kbd } from "../ui/Kbd";
import { Sheet } from "../ui/Sheet";
import { useUiStore } from "./uiStore";

function Row({ keys, label }: { keys: string[]; label: string }) {
  return (
    <div className="flex items-center justify-between gap-4 py-1.5">
      <dt className="text-sm">{label}</dt>
      <dd className="flex-none">
        <Kbd keys={keys} always />
        <span className="sr-only">{keys.map(keyLabel).join(" oder ")}</span>
      </dd>
    </div>
  );
}

/** Overview of all keyboard shortcuts, opened with "?" or the keyboard button in the header. */
export function HotkeyHelp() {
  const open = useUiStore((s) => s.hotkeyHelp);
  const setOpen = useUiStore((s) => s.setHotkeyHelp);
  return (
    <Sheet open={open} onClose={() => setOpen(false)} title="Tastenkürzel">
      <div className="space-y-4">
        <section>
          <h3 className="font-display text-base font-semibold">Spielzüge</h3>
          <dl className="mt-1 divide-y divide-line">
            {ACTION_HOTKEYS.map((h) => (
              <Row key={h.label} keys={h.keys} label={h.label} />
            ))}
          </dl>
        </section>
        <section>
          <h3 className="font-display text-base font-semibold">Bereiche</h3>
          <dl className="mt-1 divide-y divide-line">
            {TAB_HOTKEYS.map((t) => (
              <Row key={t.key} keys={[t.key]} label={t.label} />
            ))}
            <Row keys={[HELP_KEY]} label="Diese Übersicht" />
            <Row keys={["Esc"]} label="Fenster schließen" />
          </dl>
        </section>
        <p className="text-sm text-ink-2">
          Eine Taste wirkt nur, wenn die Aktion gerade erlaubt ist. Beim Tippen im Chat oder in einem Eingabefeld sind die Kürzel aus.
        </p>
      </div>
    </Sheet>
  );
}
